import * as React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHourglass } from "@fortawesome/pro-regular-svg-icons/faHourglass";
import { useTranslation } from 'react-i18next';

interface IProps {
    type?: "post" | "request" | "update",
    enabled: boolean,
    backDropOnly?: boolean,
}

export const RequestWrapIndicator: React.FC<IProps> = (props) => {
    const { t } = useTranslation();
    return (
        <div className={props.enabled ? "genie-wrap-backdrop" : ""}>

            {
                props.enabled && (props.backDropOnly == null || props.backDropOnly === false) &&
                <div className="genie-request-indicator__outer">
                    <div className="genie-request-indicator__inner">
                        <FontAwesomeIcon size="2x" fixedWidth icon={faHourglass} />
                        <br /><br />
                        <span>
                            {
                                props.type == "post"
                                    ? t("Components.AxiosHandler.Indicator.Post")
                                    : props.type == "request"
                                        ? t("Components.AxiosHandler.Indicator.Request")
                                        : t("Components.AxiosHandler.Indicator.Update")
                            }
                        </span>
                    </div>
                </div>
            }

            {props.children}

        </div >
    );
};

RequestWrapIndicator.defaultProps = { type: "request", enabled: false };